export default "__VITE_ASSET__C64D6Gf7__"